"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreemWatermark = exports.CompanyWatermark = exports.Watermark = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const icons_1 = require("../icons");
const styled_1 = __importDefault(require("@emotion/styled"));
const Watermark = () => {
    return (0, jsx_runtime_1.jsx)(icons_1.AppIcon, { name: "StreemGlyphWhiteIcon" });
};
exports.Watermark = Watermark;
exports.CompanyWatermark = styled_1.default.img(({ hide = false, height = '56px', width = '56px' }) => {
    return {
        height: height,
        width: width,
        objectFit: 'contain',
        '@media (max-height: 600px)': {
            // hide the company logo on smaller phones but only for the call lobby
            display: hide ? 'none' : 'block',
        },
    };
});
exports.StreemWatermark = (0, styled_1.default)(exports.Watermark)({
    height: '56px',
    width: '56px',
    objectFit: 'contain',
    position: 'fixed',
    top: '300px',
    left: '75px',
});
//# sourceMappingURL=watermark.js.map